const apiHost = "/api";

// cf登录  post
export const API_CF_LOGIN = `${apiHost}/login/cfmoto` //真实环境地址
// 基础数据【配置相关字典数据，如： 婚姻状况， 学历等】
export const API_BASE_DATA = `${apiHost}/data/all`;
// 基础数据 【地址数据获取】
export const API_BASE_AREA_DATA = `${apiHost}/area/pickerData`;
// 判定是否假日停办业务
export const API_HOLIDAY_VALIDATE = `${apiHost}/ignore/checkHoliday`
// cf文件上传
export const API_CF_UPLOAD = `${apiHost}/qualification/uploadImg`;
// 上传身份证正反面或者银行卡OCR认证接口 1身份证正面2身份证反面3银行卡
export const API_SYNCSCAN = `${apiHost}/qualification/imageSyncScan`;
//金融计算器
export const API_CALCULATOR = `${apiHost}/applyLoans/financialCalculator`;
//计算盗抢权益价格
export const API_DAOCHENGJIAN = `${apiHost}/applyLoans/robberyProtectionFee`
// 审核资格查询 post
export const API_GET_QUALIFICATION = `${apiHost}/qualification/result`;
// 查询 是否有融租单记录 及 资格预审状态
export const API_HAS_LOAN_AND_QUA_STATUS = `${apiHost}/applyLoans/hasHistoryLoan`;
// 发送验证码
export const API_SEND_CODE = `${apiHost}/qualification/sendPhone`
// 新增融租单号保存身份信息
export const API_ADD_INFO = `${apiHost}/qualification/add`
// 修改融租单号保存身份信息_
export const API_UPDATE_INFO = `${apiHost}/qualification/updateByInformation`
// 通过身份证号查询以前申请的资料
export const API_APPLY_OLD = `${apiHost}/originApplyLoans/findLastLoan`
// 获取资格查询结果
export const API_GET_RESULT = `${apiHost}/qualification/result`;
// 春风经销商门店
export const API_DEALER_DOOR = `${apiHost}/loan/intentionDealerList`;
// 修改融租单预审资料
export const API_update_QUal = `${apiHost}/qualification/updateQualification`;
// 联系电话
export const API_TEL = `${apiHost}/applyLoans/servicePhone`;
// 银行卡号码解析
export const API_OCRBANK = `${apiHost}/originApplyLoans/ocrBank`;
// 银行卡保存
export const API_SUBMITBANK = `${apiHost}/originApplyLoans/submitBank`;
// 根据loanId查询银行卡信息
export const API_GET_BACK = `${apiHost}/originApplyLoans/findBank`;
// 判断分期申请状态
export const API_ISAPPLY = `${apiHost}/originApplyLoans/preSubmitInsured`;
// 获取申请人和紧急联系人信息
export const API_GET_LIAISON = `${apiHost}/originApplyLoans/findInsured`;
// 盗抢车型列表
 export const API_VEHICLE_VL = `${apiHost}/brandModel/securityModels`;
 // step3 车辆及分期信息提交
export const API_APPLY_CARINS_SUB = `${apiHost}/originApplyLoans/submitCar`;
// 获取车辆及分期信息提交
export const API_APPLY_CARINS_GET = `${apiHost}/originApplyLoans/findCar`;
// 保存申请人信息和紧急联系人
export const API_SUBMIT_INSURED = `${apiHost}/originApplyLoans/submitInsured`;
// 获取用户状态
export const API_GET_STATUS = `${apiHost}/originApplyLoans/getStatus`;
// 获取分期订单
export const API_CF_ORDER_LIST = `${apiHost}/loQuery/loanState`;
// 根据loanId查询上传资料
export const API_GET_FINDDATA = `${apiHost}/originApplyLoans/findCredential`;
// 保存上传资料
export const API_SUB_FINDDATA = `${apiHost}/originApplyLoans/submitCredential`;
// 获取金融方案列表
export const API_LOAD_LIST = `${apiHost}/loaning/list`;
// 获取我的金融方案
export const API_MILOAD_LIST = `${apiHost}/loaning/getFinancePlan`;
// 查询首付能申请
export const API_GETLON = `${apiHost}/originApplyLoans/getLoanStatus`;
// 获取审批进度
export const API_APPLY_APPROVAL_GET = `${apiHost}/loan/loanApprovals`;
// 查询当前申请状态
export const API_CHECK_QUA_STATUS = `${apiHost}/applyLoans/preSubmitInsured`;
// 发起人脸识别
export const API_STARTH5FACE = `${apiHost}/originApplyLoans/startH5Face`;
// 发起签约
export const API_APPLYSIGN = `${apiHost}/originApplyLoans/applySign`;
// 获取短信
export const API_SENDMESSAGE = `${apiHost}/originApplyLoans/sendMessage`;
// 获取用户信息
export const API_GETUSERINFO = `${apiHost}/originApplyLoans/getUserInfo`;